<template>
  <div>
    <div>
      <personal-information></personal-information>
      <b-dropdown-divider v-if="availableLanguages.length > 1"></b-dropdown-divider>
    </div>

    <b-dropdown-header
      class="d-flex justify-content-center w-100"
      v-if="availableLanguages.length > 1"
    >
      <strong class="px-3 w-50 text-left">{{ content.dropdown_languague }}</strong>
      <locale-switch
        class="mt-2 mt-lg-0 w-50 text-left"
        :languages="availableLanguages"
        :languageSwitch="languageSwitch"
      ></locale-switch>
    </b-dropdown-header>
  </div>
</template>

<script>
import LocaleSwitch from './LocaleSwitch'
import PersonalInformation from './PersonalInformation'
import config from 'config'
import { mapGetters } from 'vuex'

export default {
  name: 'ProfileMenuContent',
  mixins: [],
  components: {
    LocaleSwitch,
    PersonalInformation,
  },
  computed: {
    ...mapGetters(['country']),
    availableLanguages() {
      return config['available.locales'][this.country]
    },
  },
  methods: {
    languageSwitch(newLang) {
      this.$store.dispatch('setIquoteLocale', newLang)
    },
  },
}
</script>
